export const faqs = [
  {
    id: 1,
    question: '어떤 서비스를 제공하나요?',
    answer: '① 구인·구직 광고 전용 광고페이지 디자인 ② 업체 홍보·손님 모객 전용 홈페이지 제작 두 가지만 제공합니다.',
  },
  {
    id: 3,
    question: '홈페이지로 구인도 같이 할 수 있나요?',
    answer: '기본형은 홍보·모객 전용입니다. 구인 요소 추가는 옵션이며 추가 비용이 발생합니다.',
  },
  {
    id: 4,
    question: '수정은 몇 번 가능한가요?',
    answer: '기본 수정 1회 포함입니다. 방향 변경·기획 변경은 추가 비용이 발생합니다.',
  },
  {
    id: 5,
    question: '작업 기간은 얼마나 걸리나요?',
    answer: '자료 전달 완료 기준 1~3영업일 내 제작됩니다.',
  },
];